import { testimonials } from "@/mocks/home";

export default function Testimonials() {
  const loop = [...testimonials, ...testimonials];

  return (
    <section id="customers" className="relative bg-background-50 py-20 md:py-24 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 md:px-8 mb-12">
        <div className="reveal inline-flex items-center gap-2 rounded-full border border-background-300/40 bg-background-100/50 px-4 py-1.5 mb-5">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-xs font-medium text-foreground-800 tracking-wide">Testimonials</span>
        </div>
        <h2 className="reveal font-heading text-3xl sm:text-4xl md:text-5xl font-normal text-foreground-950 leading-tight tracking-tight max-w-2xl">
          Once teams switch to Joble, they don&apos;t go back.
        </h2>
      </div>

      <div className="relative w-full overflow-hidden py-2">
        <div className="absolute top-0 bottom-0 left-0 w-16 md:w-24 bg-gradient-to-r from-background-50 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute top-0 bottom-0 right-0 w-16 md:w-24 bg-gradient-to-l from-background-50 to-transparent z-10 pointer-events-none"></div>

        <div className="flex gap-5 md:gap-6 w-max animate-marquee hover:[animation-play-state:paused]">
          {loop.map((item, index) => (
            <figure
              key={`${item.name}-${index}`}
              className="shrink-0 w-[300px] md:w-[420px] rounded-3xl border border-background-300/30 bg-background-100/45 backdrop-blur p-7 md:p-9 flex flex-col justify-between"
            >
              <div>
                <span className="block font-heading text-4xl text-primary-400 leading-none">“</span>
                <blockquote className="text-base md:text-lg font-medium text-foreground-900 leading-relaxed mt-4">
                  {item.quote}
                </blockquote>
              </div>
              <figcaption className="flex items-center gap-3.5 mt-8">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 border border-background-300/40 shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    title={`${item.name}, Joble customer`}
                  />
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-950">{item.name}</span>
                  <span className="text-xs text-foreground-600 mt-0.5">{item.role}</span>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}